import { GeneratedPronouns } from '../types/generated';

export const PronounOptions = [
  GeneratedPronouns.PronounsRatherNotSay,
  GeneratedPronouns.PronounsHeHim,
  GeneratedPronouns.PronounsSheHer,
  GeneratedPronouns.PronounsTheyThem,
];
